<template>
    <div>
        <PageHeader>
            {{ $t('productCatalog') }}
            <template #side>
                <div class="d-flex flex-wrap gap-3">
                    <TimeRangeCalendar v-model="timeRange" compare-year />
                </div>
            </template>
        </PageHeader>
        <div class="d-flex flex-column flex-xl-row gap-4">
            <div class="width-min-300 flex-grow-1 flex-basis-0">
                <ButtonIcon icon="plus" class="mb-4" @click="showModalFormProduct()">{{ $t('addNewProduct') }}</ButtonIcon>
                <ModalFormProduct />
                <ProductsTree ref="ProductsTree" :key="spaceId" @select="select" />
            </div>
            <div v-if="item" class="flex-grow-2 flex-basis-0" style="min-width: 0;">
                <CategoryStats v-if="node.raw.type === 'category'" :node="node" />
                <ProductStats v-if="node.raw.type === 'product'" :node="node" />
            </div>
            <div v-else class="flex-grow-1 flex-basis-0">
                <b-alert show variant="light" class="text-center m-3 font-weight-bold">{{ $t('chooseACategoryOrProductToSeeTheDetails') }}</b-alert>
            </div>
        </div>
    </div>
</template>



<script>
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';
    import ProductsTree from './parts/ProductsTree.vue';
    import CategoryStats from './parts/CategoryStats.vue';
    import ProductStats from './parts/ProductStats.vue';
    import ModalFormProduct from './parts/ModalFormProduct.vue';

    export default {
        name: 'ProductCatalog',
        components: {
            TimeRangeCalendar,
            ProductsTree,
            CategoryStats,
            ProductStats,
            ModalFormProduct,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
                node: null,
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            item() {
                if (!this.node) return null;
                return { id: this.node.raw.entityId, name: this.node.raw.text };
            },
        },
        watch: {
            spaceId() {
                this.node = null;
            },
        },
        methods: {
            async select(node) {
                const treeInstance = this.$refs.ProductsTree.$refs.Tree.$refs.FormSelectTree.$refs.TreeSelect;
                this.node = treeInstance.getNode(node.id);
                if (node.raw.children === true && !node.children?.length) {
                    treeInstance.loadChildrenOptions(node);
                }
            },
            showModalFormProduct() {
                this.$root.$emit('bv::show::modal', 'modal-form-space-producer-product');
            },
        },
    };
</script>
